module.exports = __webpack_public_path__ + "static/media/epicChest__top--closed.67251916.png";